import { Link } from 'react-router-dom';
import type { MovieItem } from '@/mocks/content';

interface MovieCardProps {
  item: MovieItem;
}

export default function MovieCard({ item }: MovieCardProps) {
  const subLabels: Record<string, string> = {
    dianshiju: '电视剧',
    dianying: '电影',
    zongyi: '综艺',
  };

  return (
    <Link
      to={`/article/${item.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-video overflow-hidden bg-background-200">
        <img
          src={item.imageUrl}
          alt={`${item.title} - 色影视在线观看`}
          title={`${item.title} - ${subLabels[item.category] || ''}在线观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

        {item.isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded whitespace-nowrap">
            热门
          </span>
        )}
        {item.isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded whitespace-nowrap">
            最新
          </span>
        )}

        <div className="absolute bottom-2 left-2 flex items-center gap-2">
          <span className="px-2 py-0.5 bg-black/50 backdrop-blur-sm text-white text-xs rounded whitespace-nowrap">
            {subLabels[item.category]}
          </span>
          <span className="flex items-center gap-1 text-yellow-400 text-xs">
            <i className="ri-star-fill"></i>
            {item.rating}
          </span>
        </div>
      </div>

      <div className="p-3 md:p-4">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
          {item.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
          {item.description}
        </p>
        <div className="mt-2 flex items-center gap-2 text-xs text-foreground-400">
          <span>{item.year}</span>
          <span>·</span>
          <span>{item.subcategory}</span>
        </div>
      </div>
    </Link>
  );
}